import { useState } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { FormattedMessage } from 'react-intl';
import globalMessages from '../../../config/globalMessages';

function InfoButton({ infoText }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'info-popover' : undefined;

  if (globalMessages[infoText]) {
    return (
      <>
        <IconButton size="small" onClick={handleClick} aria-describedby={id} style={{ padding: '2px' }}>
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}>
          <Typography sx={{ p: 1, maxWidth: '250px' }}>
            <FormattedMessage {...globalMessages[infoText]} />
          </Typography>
        </Popover>
      </>
    );
  }
}

export default InfoButton;
